module.exports = __webpack_public_path__ + "static/media/traffic-roadworks.9ccfeaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/traffic-roadworks.svg
// module id = 903
// module chunks = 0